/**
 * "¿De qué socio es?" — los chips que comparten el retiro de caja, el aporte y
 * la salida de mercaderia.
 *
 * No viene ninguno marcado: un socio puesto de antemano es el que queda cuando
 * nadie mira, y la cuenta entre los dos se tuerce sin que nadie lo note.
 */
import { Label } from "@/components/ui/label";
import { Segmented } from "@/components/ui/segmented";
import type { Socio } from "@/lib/tipos";

export interface ChipsSocioProps {
  socios: ReadonlyArray<Socio>;
  /** El id como texto, o "" si todavia no se eligio. */
  valor: string;
  onChange: (valor: string) => void;
  ayuda?: string;
}

export function ChipsSocio({ socios, valor, onChange, ayuda }: ChipsSocioProps): JSX.Element {
  return (
    <div className="space-y-1.5">
      <Label>¿De qué socio es?</Label>
      <Segmented
        apariencia="chips"
        tamano="sm"
        etiqueta="Socio"
        opciones={socios.map((s) => ({ valor: String(s.id), etiqueta: s.nombre }))}
        valor={valor}
        onChange={onChange}
      />
      {ayuda ? <p className="text-xs text-muted-foreground">{ayuda}</p> : null}
    </div>
  );
}
